import { Box, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ScrollToHash from '../../components/scrollToHash';
import inky from '../../assets/inky-children.png';

const About = () => {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <div>
      <ScrollToHash />
      <Typography
        style={{
          fontFamily: 'Baloo2',
          fontSize: isMobile ? '28px' : '48px',
          fontWeight: 800,
          color: 'white',
          textAlign: 'center',
          paddingBottom: '40px'
        }}>
        ABOUT US
      </Typography>
      <div style={{ margin: isMobile ? '0 5%' : '0 10%', color: 'white' }}>
        <Typography
          style={{
            fontSize: isMobile ? '28px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Where Every Effort Counts!
        </Typography>
        <Typography
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 500,
            padding: '10px'
          }}>
          At Champsverse, we believe that every child is a superstar—not for just winning, but for trying, creating, and
          growing. In today’s digital age, children spend countless hours on passive screen time, leading to
          distractions and reduced focus. We’re here to change that cycle.
        </Typography>
        <Typography
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 500,
            padding: '10px'
          }}>
          Champsverse is the world’s first hybrid creative platform that blends online engagement with offline
          creativity. We set fun, skill-building challenges for children—whether it’s painting, writing, storytelling,
          sculpting, or any creative expression. But here’s the catch: they must complete their tasks offline. Once they
          upload their work, they’re rewarded with coins, badges, club memberships, and valuable recognitions.
        </Typography>
        <Typography
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 500,
            padding: '10px'
          }}>
          The most important aspect of these activities is that Champsverse helps children discover and appreciate the
          most meaningful dimensions of life — including human values, environmental awareness, ecology, history,
          culture, heritage, science, modern technology, and beyond.
        </Typography>
        <Typography
          style={{
            fontSize: isMobile ? '28px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          A Healthy Dopamine Boost!
        </Typography>
        <Typography
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 500,
            padding: '10px'
          }}>
          Instead of the instant, passive dopamine spikes from endless scrolling or gaming, Champsverse trains children
          to associate effort and focus with real rewards. Our unique approach ensures they feel motivated, confident,
          and engaged in productive habits—all while developing lifelong creative skills.
        </Typography>
        <Typography
          style={{
            fontSize: isMobile ? '28px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Meet Finly – The AI That Understands Your Child
        </Typography>
        {isMobile ? (
          <div>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={inky} alt={'inky'} style={{ width: '250px', height: '250px' }}></img>
            </Box>
            <Typography
              style={{
                fontSize: isMobile ? '14px' : '24px',
                fontFamily: 'Baloo2',
                fontWeight: 500,
                padding: '10px'
              }}>
              At the heart of Champsverse is Finly, our AI-powered mentor that tailors activities to match each child’s
              interests, skills, and growth potential. With Finly, every challenge is personal, engaging, and designed
              to push their creative boundaries.
            </Typography>
          </div>
        ) : (
          <div style={{ display: 'flex' }}>
            <img src={inky} alt={'inky'} style={{ width: '350px', height: '350px' }}></img>
            <div style={{ width: '60%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography
                style={{
                  fontSize: isMobile ? '14px' : '24px',
                  fontFamily: 'Baloo2',
                  fontWeight: 500,
                  padding: '10px'
                }}>
                At the heart of Champsverse is Finly, our AI-powered mentor that tailors activities to match each
                child’s interests, skills, and growth potential. With Finly, every challenge is personal, engaging, and
                designed to push their creative boundaries.
              </Typography>
            </div>
          </div>
        )}
        <Typography
          style={{
            fontSize: isMobile ? '28px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          A Lifetime Treasure of Achievements
        </Typography>
        <Typography
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 500,
            padding: '10px'
          }}>
          Every submission on Champsverse becomes part of a child’s digital creative portfolio—a collection of their
          hard work and milestones, cherished by parents. Families can store, preserve, and even download this creative
          journey, ensuring memories last a lifetime.
        </Typography>
        <Typography
          style={{
            fontSize: isMobile ? '28px' : '48px',
            fontFamily: 'Baloo2',
            fontWeight: 800
          }}>
          Our Mission
        </Typography>
        <Typography
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 500,
            padding: '10px'
          }}>
          We’re on a mission to rescue children from passive screen addiction and turn their time into talent. With
          Champsverse, kids experience the joy of earning rewards for real effort, while parents witness their growth,
          confidence, and creativity flourish.
        </Typography>
        <Typography
          style={{
            fontSize: isMobile ? '14px' : '24px',
            fontFamily: 'Baloo2',
            fontWeight: 500,
            padding: '10px'
          }}>
          Join us in building a future where every child’s creativity is celebrated, treasured, and rewarded. 🚀✨
        </Typography>
      </div>
    </div>
  );
};
export default About;
